import React, { useCallback, useState, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { localizeInterval } from "../../../../../../common/parameters";

import { SvgCanvas, Button } from "../IntervalsLadder/IntervalButton/styles";
import Grid from "../IntervalsLadder/IntervalButton/Grid";

import { Container, Modal, DemoContainer, DragSimulator } from "./styles";
import messages from "./messages";
import { get, set } from "./store";

const DragHintModal = () => {
    const { locale } = useIntl();
    const [isVisible, setVisible] = useState(false);
    const handleClick = useCallback(() => {
        set();
        setVisible(false);
    }, []);

    useEffect(() => {
        if (!get()) {
            setVisible(true);
        }
    }, []);

    if (!isVisible) return null;
    const text = localizeInterval("N3", locale);
    const isNumberLast = text[text.length - 1] === "3";
    return (
        <Container>
            <Modal>
                <p>
                    <FormattedMessage {...messages.hint} />
                </p>
                <DemoContainer>
                    <SvgCanvas
                        style={{
                            top: 0,
                            left: 0,
                        }}
                    >
                        <Grid width={[-0.5]} />
                        <Grid width={[0.5]} />
                    </SvgCanvas>
                    <DragSimulator>
                        <Button className="Button">
                            {isNumberLast ? (
                                <>
                                    <span className="Marker">{text.slice(0, text.length - 1)}</span>
                                    {text.slice(-1)}
                                </>
                            ) : (
                                <>
                                    {text.slice(0, 1)}
                                    <span className="Marker">{text.slice(1)}</span>
                                </>
                            )}
                        </Button>
                    </DragSimulator>
                </DemoContainer>
                <button className="button button--full-width" onClick={handleClick}>
                    <FormattedMessage {...messages.close} />
                </button>
            </Modal>
        </Container>
    );
};

export default DragHintModal;
